import {
  BreakpointAction,
  ChoiceFunction,
  GoalBreakpointOption,
  QuizDataInput,
} from '@naturalcycles/shared'
import { allQuizSections } from '@src/app/cnst/quiz/quiz.cnst'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst'
import { addPageToFlowAfterCurrent } from '@src/app/util/quiz.util'
import { DefaultQuizSection } from '@src/typings/quiz.enum'

export enum LastPeriodDatesOptionOuraSyncABTest {
  addPeriod = 1,
  skip = 2,
}

const lastPeriodQuizPages = [
  QuizPage.lastPeriodDate0,
  QuizPage.lastPeriodDate1,
  QuizPage.lastPeriodDate2,
  QuizPage.lastPeriodDate3,
  QuizPage.lastPeriodDate4,
  QuizPage.lastPeriodDate5,
]

const addLastPeriodTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = (flow, data) => {
  const periodIndex = data?.lastPeriodDates?.length ? data.lastPeriodDates.length - 1 : -1
  const periodIndexIsOutOfRange = periodIndex < 0 || periodIndex > lastPeriodQuizPages.length
  if (periodIndexIsOutOfRange) return flow

  const currentPage = lastPeriodQuizPages[periodIndex]
  const nextPage = lastPeriodQuizPages[periodIndex + 1]

  if (!currentPage || !nextPage) return flow

  const updatedFlow = addPageToFlowAfterCurrent(
    flow,
    DefaultQuizSection.cycle,
    currentPage,
    nextPage,
  )

  return updatedFlow
}

const skipTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = (flow, data) => {
  const periodIndex = data?.lastPeriodDates?.length ?? 0
  const goal = data?.fertilityGoal

  if (periodIndex > lastPeriodQuizPages.length) return flow

  const currentPage = lastPeriodQuizPages[periodIndex]
  const cycleSection = flow[allQuizSections.cycle]

  if (!currentPage || !cycleSection) return flow

  const keepUpToIndex = cycleSection.indexOf(currentPage) + 1
  const updatedCycleSection = cycleSection.slice(0, keepUpToIndex)

  if (goal === GoalBreakpointOption.plan) {
    flow[allQuizSections.cycle] = [...updatedCycleSection, QuizPage.medicalConditionsPlan]
    return flow
  }

  flow[allQuizSections.cycle] = [...updatedCycleSection, QuizPage.medicalConditionsPrevent]

  return flow
}

export const addLastPeriodDatesOuraSyncABTest: BreakpointAction<
  LastPeriodDatesOptionOuraSyncABTest,
  QuizPage,
  QuizDataInput
> = {
  [LastPeriodDatesOptionOuraSyncABTest.addPeriod]: addLastPeriodTransformFunction,
  [LastPeriodDatesOptionOuraSyncABTest.skip]: skipTransformFunction,
}
